import Flex from '@components/layout/flex';
import * as React from 'react';
import Typography from '@components/basics/typography';
import { Link } from 'react-router-dom';
import CircleCheckIcon from '@components/basics/icons/circle-check';
import UnselectedIcon from '@components/basics/icons/unselected';
import styled from 'styled-components';
import Button from '@components/actions/button';
import { UpdateAgreement } from '@webapp/store/terms/action-creators';
import { TermsToAccept } from '@webapp/store/terms/state';

const TermsToLinkMap: {
  [key in TermsToAccept]: { link: string; title: string };
} = {
  terms: {
    link: '/terms-of-service/',
    title: 'Terms of Service',
  },
  privacyPolicy: {
    link: '/privacy-policy/',
    title: 'Privacy Policy',
  },
  distributionTerms: {
    link: '/distribution-agreement',
    title: 'Distribution Terms',
  },
};

export interface TermsAgreementProps {
  className?: string;
  term: TermsToAccept;
  updateAgreement: () => UpdateAgreement;
  callback?: () => any;
}

const TermsAgreement: React.FC<TermsAgreementProps> = (props) => {
  const { updateAgreement, callback, className } = props;
  const { link, title } = TermsToLinkMap[props.term];
  const [agreed, setAgreed] = React.useState(false);

  const onConfirm = React.useCallback(() => {
    updateAgreement();
    callback && callback();
  }, [updateAgreement, callback]);

  return (
    <Flex flexDirection="column" alignItems="center" className={className}>
      <Typography type="subheader" className="mb-15">
        {title}
      </Typography>
      <Typography className="mt-10" type="small">
        Please take your time to read and accept the new {title} in order to
        <br />
        continue using trac and its services.
      </Typography>
      <CheckBoxWrapper>
        <span className="checkboxText">
          I accept the new{' '}
          <Link className="link" to={link} target="_blank">
            {title}
          </Link>
        </span>
        {agreed ? (
          <CircleCheckIcon onClick={() => setAgreed(!agreed)} />
        ) : (
          <UnselectedIcon onClick={() => setAgreed(!agreed)} />
        )}
      </CheckBoxWrapper>
      {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
      <Button fullWidth disabled={!agreed} onClick={onConfirm}>
        Confirm
      </Button>
      <DontAgreeLink href="https://tracco.zendesk.com/hc/" target="_blank">
        Don’t agree with the new {title}?
      </DontAgreeLink>
    </Flex>
  );
};
export default TermsAgreement;

const CheckBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 68px;
  width: 100%;
  margin: 40px 0 10px 0;
  padding: 18px;
  font-size: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  .checkboxText {
    padding-right: 20px;
  }
  .link {
    color: ${({ theme }) => theme.colors.accent};
  }
  @media ${({ theme }) => theme.device.mobileL} {
    padding: 26px 18px;
  }
`;

const DontAgreeLink = styled.a`
  margin-top: 40px;
  font-size: 12px;
`;
